import { MenuContent, MenuContentItem } from '@models/interfaces/components/Menu.interface';

export function flattenMenuContent(items: MenuContent[]): MenuContent[] {
  return items.flatMap((item: MenuContent): MenuContent[] => [
    item,
    ...flattenMenuContent(item.data.children ?? [])
  ]);
}

export function findMenuContentById(items: MenuContent[], id: MenuContentItem['id']): MenuContent | undefined {
  return flattenMenuContent(items).find((item: MenuContent): boolean => String(item.data.id) === String(id));
}
